import { createContext } from 'react';
var HighchartsContext = createContext();
HighchartsContext.displayName = 'HighchartsContext';
export default HighchartsContext;